// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IWebGetMapDataRequest, TWebGetMapDataModel, IMappers, TWebGetMapDataResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetMapDataResponseSchema } from '../../../entities/user_folder/GetMapDataResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebGetMapDataModel(parameters: IWebGetMapDataRequest): TWebGetMapDataModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'favorites',
    pathApi: '/v1/web/get-map-data/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IWebGetMapDataOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IWebGetMapDataRequest;
}

export async function fetchWebGetMapData<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebGetMapDataOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebGetMapDataResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebGetMapDataModel(parameters),
    config,
  )) as FetchResponse<TWebGetMapDataResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetMapDataResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebGetMapDataResponse>;
}
